import styles from './page.module.scss';
import React, {CSSProperties} from 'react';

interface OwnProps {
    children: React.ReactNode;
    style?: CSSProperties;
}

export function PageTitle({children, style}: OwnProps) {
    return (
        <div style={style} className={styles.page__title}>
            {children}
        </div>
    );
}
